import React from "react";
import SearchBarIntroSection from "./SearchBarIntroSection/SearchBarIntroSection";
import RoundedLinkButton from "../../../components/Buttons/RoundedLinkButton/RoundedLinkButton";
import PopularSearches from "./PopularSearches/PopularSearches";
import "./newIntroSection.css";
// import heroImg from "../../../assets/images/stockholm.webp";

export default function NewIntroSection() {
  return (
    <section className="new-hero-section">
      <img
        src="/images/hero/stockholm.webp"
        alt="Bild över Stockholm"
        fetchpriority="high"
        className="new-hero-image"
        width="1854"
        height="1132"
      ></img>
      <div className="new-hero-overlay"></div>
      <div className="new-hero-intro">
        <div className="new-hero-arrow">
          <svg
            width="15rem"
            height="15rem"
            viewBox="0 -34.5 245 245"
            fill="none"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            transform="matrix(1, 0, 0, 1.2, 0, 0)rotate(290)"
          >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
              id="SVGRepo_tracerCarrier"
              strokeLinecap="round"
              strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
              {" "}
              <path
                d="M0.689053 159.489C7.44031 160.759 14.1916 162.03 22.2087 163.512C21.1538 160.759 20.5209 158.853 19.466 156.947C-1.20972 116.501 5.33053 73.3014 36.977 40.4783C57.4418 19.5139 82.759 8.71403 111.03 2.78469C142.676 -3.77994 172.846 1.72588 201.961 14.4316C216.94 20.9962 228.544 31.7961 238.46 44.5018C240.991 47.89 243.312 51.2782 245 55.937C242.89 54.6664 240.359 53.6076 239.093 51.7017C206.391 6.17288 128.963 -4.62699 73.0541 25.2315C51.1125 36.8784 34.6563 54.0311 24.7404 76.9014C13.1367 103.795 17.9891 139.159 36.5551 161.183C40.3527 151.653 36.977 139.371 47.7369 131.748C47.3149 145.301 47.1039 157.583 46.682 169.653C46.471 173.677 44.3612 176.853 40.5637 175.794C27.4831 172.406 14.6135 168.594 1.95493 164.571C1.11102 164.359 0.689046 162.453 0.0561163 161.394C-0.15486 160.971 0.267099 160.124 0.689053 159.489Z"
                fill="#fff"
              ></path>{" "}
            </g>
          </svg>
        </div>
        <div data-testid="home-intro-title" className="new-hero-content">
          <h1 className="new-hero-title">
            Hyr lokal eller hyr ut lokal med <br /> Vakansa idag!
          </h1>
          <div>
            <SearchBarIntroSection />
            <PopularSearches />
          </div>
          <RoundedLinkButton
            href="/hyr-ut-lokal"
            label="Hyr ut din lokal här"
            color="green"
            size="lg"
          />
        </div>
      </div>
    </section>
  );
}
